import { render } from "./ButtonsMessage.vue?vue&type=template&id=7a81fcf6&scoped=true&ts=true"
import script from "./ButtonsMessage.vue?vue&type=script&lang=ts"
export * from "./ButtonsMessage.vue?vue&type=script&lang=ts"

import "./ButtonsMessage.vue?vue&type=style&index=0&id=7a81fcf6&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a81fcf6"]])

export default __exports__